import Model from "./Model";

export type TherapyState = "active" | "paused" | "ended" | "scheduled";

/** A patient's therapy, as far as reminders need. */
export default class Therapy extends Model {
  static type = "therapies";

  drugName: string;
  doseText: string;
  timesOfDay: string[];
  everyNDays: number;
  startsOn: string;
  endsOn: string | null;
  pausedAt: string | null;
  state: TherapyState;
  nextReminderAt: string | null;
  recentReminders: { scheduledAt: string; status: string; errorMessage: string | null }[];
}
